// All product data scraped from xpeditionz.co.nz

const BASE = "https://www.xpeditionz.co.nz";

export const HERO_IMAGES = {
  home: "/products/bushcabin/bushcabin-storysplit-rear-driveaway.webp",
  wellside: "/products/wellsides/731077_327661e3e2154fd9968715252cb80dc5~mv2_hero_extended.jpeg",
  wellsideMobile: "/products/wellsides/731077_327661e3e2154fd9968715252cb80dc5~mv2_hero_extended_mobile.jpeg",
  xseries: "https://static.wixstatic.com/media/731077_b3ea68f35e164ccaa5b49ac07c720c73f000.jpg/v1/fill/w_1920,h_1080,al_c,q_85,enc_avif,quality_auto/731077_b3ea68f35e164ccaa5b49ac07c720c73f000.jpg",
  xseriesVideo1080: "https://video.wixstatic.com/video/731077_b3ea68f35e164ccaa5b49ac07c720c73/1080p/mp4/file.mp4",
  xseriesVideo720: "https://video.wixstatic.com/video/731077_b3ea68f35e164ccaa5b49ac07c720c73/720p/mp4/file.mp4",
  xseriesVideo480: "https://video.wixstatic.com/video/731077_b3ea68f35e164ccaa5b49ac07c720c73/480p/mp4/file.mp4",
  xseries2: "https://static.wixstatic.com/media/731077_dea721d040ae43b38580b23e56ac1c8d~mv2.jpg/v1/fill/w_2435,h_1826,al_b,q_90,enc_avif,quality_auto/731077_dea721d040ae43b38580b23e56ac1c8d~mv2.jpg",
  xseries3: "https://static.wixstatic.com/media/731077_c83f0402209a4e5caece6cf599b395ed~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,enc_avif,quality_auto/731077_c83f0402209a4e5caece6cf599b395ed~mv2.jpg",
  bushcabin: "/products/bushcabin/bushcabin-hero-beachscene-v2.jpg",
  bushcabin2: "/products/bushcabin/bushcabin-interior-dinner-table.webp",
  bushcabin3: "/products/bushcabin/731077_be9990f0da2945baa2b08b80ab119cbc~mv2.jpg",
  loadDemo: "/products/bushcabin/20250127_122906.jpg",
  xseriesDetail: "https://static.wixstatic.com/media/731077_5633f69634574833b3ab5ce5a020fb1f~mv2.jpg/v1/fill/w_2849,h_1636,al_c,q_90,usm_0.33_1.00_0.00,enc_avif,quality_auto/731077_5633f69634574833b3ab5ce5a020fb1f~mv2.jpg",
  xseriesDemo: "https://static.wixstatic.com/media/731077_10874b4ada9e41bda1905b9925e9d6ad~mv2.jpg/v1/fill/w_1761,h_992,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/731077_10874b4ada9e41bda1905b9925e9d6ad~mv2.jpg",
  bushCabinDoors: "/products/bushcabin/731077_0405a8edf58740268dc5877b90aebb17~mv2.jpg",
  wellsideHilux: "/products/wellsides/731077_965bc7e8fce44fa38c6bb966e7a68bdf~mv2.jpg",
  xseriesDuo: "https://static.wixstatic.com/media/731077_9c77e41aab104d64899f4d393ed582e9~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/20250218_095932.jpg",
  bushCabinOpened: "/products/bushcabin/bushcabin-opened-beach.jpg",
  bushCabinSetup: "/products/bushcabin/731077_a9c53210613e465c9de09588cef16620~mv2.jpg",
};

export const STATS_MARQUEE = [
  "300KG DYNAMIC LOAD",
  "TESTED TO 2.5 TONNES",
  "10-YEAR FRAME GUARANTEE",
  "TIG-WELDED ALUMINIUM",
  "TRUSTED BY NZ DEALERSHIPS",
  "MADE IN SOUTH AFRICA",
  "OEM-GRADE FINISH",
  "EXPEDITION TESTED",
];
